import React, { useMemo } from 'react';
import CameraIcon from '../../../../assets/icons/camera_raw.svg';
import uniqueId from '../../../../utils/uniqueId';
import Tooltip from '../../Tooltip';
import styles from './Snapshot.module.scss';

const Snapshot = ({ onClick, tooltip, number }) => {
  const tooltipId = useMemo(() => uniqueId('snapshotButton'), []);
  const disabled = number >= 500000;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <button
        type="button"
        className={styles.button}
        data-for={tooltipId}
        data-tip
        onClick={handleClick}
        disabled={disabled}
      >
        <CameraIcon height="16px" width="16px" />
      </button>
      <Tooltip
        id={tooltipId}
        info={disabled ? 'Too many contacts to create a list' : tooltip}
      />
    </>
  );
};

export default Snapshot;
